import * as App from '../../app';
import bridge from '@vkontakte/vk-bridge';
import { SettingsModal } from '../../modals';
export function settingsModal(props) {
    var settingsModal = new SettingsModal({
        onChangeColorTheme: function (name) {
            props.rootEl.classList.remove("".concat(App.themes.get().name, "-theme"));
            props.rootEl.classList.add("".concat(name, "-theme"));
            App.themes.set(name);
            props.game.reDraw();
            App.sounds.clickButton();
            props.updatePreviewOnStartScreen();
        },
        onClickInviteBtn: function () {
            if (FOR_VK) {
                bridge
                    .send('VKWebAppShowInviteBox', {})
                    .then(function (data) { return console.log(data.success); })
                    .catch(function (error) { return console.log(error); });
                App.sounds.clickButton();
                settingsModal.close();
                App.stat.params({ buttons: { invite: 1 } });
            }
        },
        onClickReplyBtn: function () {
            if ((FOR_YANDEX || FOR_VK) && App.settings.get().showNativeOnReply) {
                App.Fn.showNative(function () { return props.startGame(); });
            }
            else {
                props.startGame();
            }
            App.stat.params({ buttons: { reply: 1 } });
            settingsModal.close();
            App.sounds.clickButton();
        },
        onChangeCancelMoveFeature: function () {
            setTimeout(function () { return props.game.reDraw(); }, 25);
        },
        onClickDebug: function () {
            settingsModal.close();
            props.debugScreen().show();
            App.sounds.clickButton();
        },
        onClickGlobalRating: function () {
            props.leaderBoard().show();
            settingsModal.close();
            App.stat.params({ buttons: { globalRating: 1 } });
            App.sounds.clickButton();
        },
        friendsRating: (FOR_VK && DEVELOPMENT) || exceptDesktopPlatform(),
        onClickFriendsRating: function () {
            onClickLeaderBoardButton();
        },
        onClickShowShareBox: function () {
            App.Fn.wallPost();
            settingsModal.close();
        },
        onClickDailyBonus: function () {
            if (App.features.DAILY_BONUS_FEATURE) {
                props.dailyBonusModal().show();
                settingsModal.close();
                App.stat.params({ buttons: { dailyBonus: 1 } });
                App.sounds.clickButton();
            }
        },
    });
    // https://dev.vk.com/bridge/VKWebAppShowLeaderBoardBox
    function onClickLeaderBoardButton() {
        if (props.game.isTimerEffect()) {
            App.sounds.disabled();
            return;
        }
        if (FOR_VK) {
            var _a = App.storage.get(), score = _a.score, maxScore = _a.maxScore;
            var params = { user_result: Math.max(1, score, maxScore), global: 0 };
            bridge
                .send('VKWebAppShowLeaderBoardBox', params)
                .then(function (data) {
                console.log(data.success);
                props.debugScreen().log(data);
            })
                .catch(function (error) {
                props.debugScreen().log(error);
                console.log(error);
            });
        }
        if (FOR_YANDEX) {
            props.leaderBoard().show();
        }
        App.stat.params({ buttons: { rating: 1 } });
        App.sounds.click();
    }
    return settingsModal;
}
function exceptDesktopPlatform() {
    return FOR_VK ? checkVkPlatform(['html5_android', 'html5_mobile', 'html5_ios']) : false;
}
function checkVkPlatform(whiteList) {
    if (FOR_VK) {
        var params = new URLSearchParams(location.search);
        if (params.has('platform')) {
            return whiteList.includes(params.get('platform'));
        }
    }
    return false;
}
